/**
 * Cadê o carro — tela própria (lote de aparência 2, PO 17/09/2026): o bloco
 * saiu da Home e passou a viver no Mais. O conteúdo é o mesmo de antes: o
 * carro marcado (foto da fileira, nota, "Como chegar", desmarcar) ou o botão
 * "Estacionei aqui". No Mapa o carro continua aparecendo como pino.
 */
import { featureEnabled } from '@nv/core';
import { useEffect, useState } from 'react';

import { useTrip } from '../../trip/TripContext';
import { Icon } from '../../ui/icons';
import { Ilustracao } from '../../ui/Ilustracao';
import { Toast } from '../../ui/Toast';
import { EmptyState, Skeleton } from '../../ui/primitives';
import { useCarro, useInvalidarCarro } from './api';
import { CarroCard } from './CarroCard';
import { EstacioneiAqui } from './EstacioneiAqui';

export function CarroScreen() {
  const { trip, tripId } = useTrip();
  const ligado = featureEnabled(trip.features, 'carro');
  const carro = useCarro(tripId, ligado);
  useInvalidarCarro(tripId);
  const [marcando, setMarcando] = useState(false);
  // Confirmação visual das duas pontas (refino final): o toast é local à tela.
  const [toast, setToast] = useState<string | null>(null);
  useEffect(() => {
    if (!toast) return;
    const t = window.setTimeout(() => setToast(null), 2600);
    return () => window.clearTimeout(t);
  }, [toast]);

  return (
    <section className="screen carro-tela">
      <h1>Cadê o carro</h1>
      {!ligado && (
        <EmptyState ilustracao="carro" title="Desligado nesta viagem" description="Quem administra liga em Configurações da viagem." />
      )}
      {ligado && carro.isLoading && <Skeleton height={120} />}
      {ligado && carro.data?.car && (
        <>
          <CarroCard carro={carro.data.car} comMapa onPeguei={() => setToast('Carro liberado · foto apagada')} />
          <p className="carro__privacidade">A foto fica só aqui, para a sua família achar o carro. Não entra nas Memórias e some quando alguém pega o carro.</p>
        </>
      )}
      {ligado && carro.data && !carro.data.car && (
        <div className="carro__vazio nv-enter">
          <Ilustracao nome="carro" tamanho={160} className="nv-float" />
          <h2 className="carro__vazio-titulo">Onde ficou o carro?</h2>
          <p className="carro__vazio-texto">Marque a vaga ao estacionar, com a fileira e uma foto da placa. Sua família acha sem perguntar no grupo.</p>
          <button type="button" className="nv-btn nv-btn--primary nv-btn--pilula carro__estacionei" onClick={() => setMarcando(true)} data-testid="estacionei">
            <Icon name="local" size={20} /> Estacionei aqui
          </button>
        </div>
      )}
      {marcando && <EstacioneiAqui onFechar={() => setMarcando(false)} onGuardado={() => setToast('Vaga marcada · a família já vê')} />}
      {toast && <Toast texto={toast} />}
    </section>
  );
}
